import { DelimitedNumericArrayParam } from 'use-query-params';

export const reportSectionPath = '/reports' as const;

export const reportsSubpagePaths = {
  AggregateReports: `${reportSectionPath}/aggregated`,
  AggregatedManageMarking: `${reportSectionPath}/aggregated/manage-marking/:responseId`,
  AggregatedMarkResponse: `${reportSectionPath}/aggregated/mark-response/:responseId`,
  LearnerReports: `${reportSectionPath}/learner-reports`,
  LearnerReport: `${reportSectionPath}/learner-reports/:assessmentUserId`,
  LearnerProgressReports: `${reportSectionPath}/learner-reports/progress/:customerUserId`,
  LearnerWhānauReports: `${reportSectionPath}/learner-reports/whānau/:areaId`,
  ProgressOvertimeReports: `${reportSectionPath}/progress-over-time`
} as const;

type Keys = keyof typeof reportsSubpagePaths;
type ReportsSubpagePath = (typeof reportsSubpagePaths)[Keys];

/**
 * Converts a subpage path into a slug by removing the proceeding reports page path and forward slash.
 */
export function slug(path: ReportsSubpagePath): string {
  return path.substring(`/${reportSectionPath}`.length);
}

/**
 * Create a link to the learner report area
 * - requires a assessment user id to be provided
 */
export function goToLearnerReport(assessmentUserId: number): string {
  return `${reportsSubpagePaths.LearnerReport.replace(':assessmentUserId', `${assessmentUserId}`)}`;
}

/**
 * Create a link to the learner progress reports
 * - requires a customer user id to be provided
 */
export function goToLearnerProgressReports(customerUserId: number): string {
  return `${reportsSubpagePaths.LearnerProgressReports.replace(':customerUserId', `${customerUserId}`)}`;
}

/**
 * Create a link to the whānau report
 * - requires an intended area id
 * - requires an array of learnerIds (customer users)
 */
export function goToWhānauReport(areaId: number, learnerIds: number[]): string {
  return `${reportsSubpagePaths.LearnerWhānauReports.replace(':areaId', `${areaId}`)}?organisationUserIds=${DelimitedNumericArrayParam.encode(learnerIds)}`;
}
